import { render, staticRenderFns } from "./TransactionRecord.vue?vue&type=template&id=28292b4f&scoped=true"
import script from "./TransactionRecord.vue?vue&type=script&lang=js"
export * from "./TransactionRecord.vue?vue&type=script&lang=js"
import style0 from "./TransactionRecord.vue?vue&type=style&index=0&id=28292b4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28292b4f",
  null
  
)

export default component.exports